/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanStatusInfo { 
    status?: PlanStatusInfo.StatusEnum;
    planId?: number;
    planName?: string;
    cpfCnpj?: string;
    allowsAccess?: boolean;
    requiresAction?: boolean;
    createdAt?: string;
    updatedAt?: string;
    expiresAt?: string;
    daysRemaining?: number;
    lastPaymentDate?: string;
    nextPaymentDate?: string;
    daysOverdue?: number;
    totalValue?: number;
    pendingAmount?: number;
    message?: string;
    isActive?: boolean;
    packageType?: PlanStatusInfo.PackageTypeEnum;
}
export namespace PlanStatusInfo {
    export type StatusEnum = 'NO_PLAN' | 'ACTIVE' | 'INACTIVE' | 'EXPIRING_SOON' | 'EXPIRED' | 'PAYMENT_OVERDUE' | 'SUSPENDED' | 'TRIAL' | 'PENDING_PAYMENT';
    export const StatusEnum = {
        NoPlan: 'NO_PLAN' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum,
        ExpiringSoon: 'EXPIRING_SOON' as StatusEnum,
        Expired: 'EXPIRED' as StatusEnum,
        PaymentOverdue: 'PAYMENT_OVERDUE' as StatusEnum,
        Suspended: 'SUSPENDED' as StatusEnum,
        Trial: 'TRIAL' as StatusEnum,
        PendingPayment: 'PENDING_PAYMENT' as StatusEnum
    };
    export type PackageTypeEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const PackageTypeEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as PackageTypeEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as PackageTypeEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as PackageTypeEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as PackageTypeEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as PackageTypeEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as PackageTypeEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as PackageTypeEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as PackageTypeEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as PackageTypeEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as PackageTypeEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as PackageTypeEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as PackageTypeEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as PackageTypeEnum
    };
}


